import { motion } from "framer-motion";
import { MODULE_META } from "../lib/resourcesData";

export default function ResourceCard({ resource, index = 0 }) {
  const meta = MODULE_META[resource.module];

  return (
    <motion.a
      href={resource.file}
      download
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.45, delay: index * 0.08, ease: "easeOut" }}
      className="group relative flex flex-col bg-surface-card-light dark:bg-surface-card-dark backdrop-blur-lg border border-glass rounded-xl p-card-padding overflow-hidden hover:-translate-y-1 transition-all duration-300 shadow-sm hover:shadow-md h-full"
    >
      <div className={`absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r ${meta.accentGradient}`} />

      <div className="flex items-start justify-between gap-4 mb-stack-md">
        <span className={`font-label-sm text-label-sm uppercase tracking-widest ${meta.accentText}`}>
          {resource.typeLabel}
        </span>
        <span className="font-data-mono text-data-mono text-on-surface-variant dark:text-surface-variant whitespace-nowrap">
          {resource.pages === 1 ? "1 page" : `${resource.pages} pages`}
        </span>
      </div>

      <h3 className="font-headline-card text-headline-card text-on-surface dark:text-surface-bright mb-2">
        {resource.title}
      </h3>

      <p className="font-body-md text-body-md text-on-surface-variant dark:text-surface-variant mb-stack-md flex-grow">
        {resource.description}
      </p>

      <p className="font-label-sm text-label-sm text-on-surface-variant dark:text-surface-variant opacity-70 mb-stack-lg">
        Best for: {resource.useCase}
      </p>

      <span
        className={`inline-flex items-center gap-2 font-label-sm text-label-sm uppercase ${meta.accentText} group-hover:gap-3 transition-all`}
      >
        <span className="material-symbols-outlined text-[18px]">download</span>
        Download PDF
      </span>
    </motion.a>
  );
}
